module.exports = __webpack_public_path__ + "assets/img/star3.1cf06713.webp";